/* Mikaya — welcome offer controller (rev 2026-09-13).
   Old behaviour interrupted every visit 5s after landing (sessionStorage only).
   Now:
   - A small "10% off" tab appears after ~20s of engaged time. Clicking it opens the offer.
   - The full popup only opens by itself on real intent to leave:
       desktop: cursor leaves through the top, after 15s engaged
       mobile:  90s engaged across the visit AND (scrolled half a page OR on a 2nd page)
   - It opens by itself at most once every 14 days, and never after sign-up.
   - Never auto-shown on cart, checkout, account, the course page or the B2B pages.
   - While the tab is in the background, its title gently mentions the offer. */
(function () {
  var root = document.querySelector('[data-mk-welcome]');
  if (!root) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var K_SIGNED = 'mk-wp-signed', K_AUTO = 'mk-wp-auto-at', K_TEASE_OFF = 'mk-wp-teaser-off-at',
      K_MS = 'mk-wp-engaged-ms', K_PAGES = 'mk-wp-pages';
  var DAY = 864e5, COOLDOWN = 14 * DAY;
  var TEASER_AFTER = 1500, DESKTOP_MIN = 15e3, MOBILE_AFTER = 90e3;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, String(v)); } catch (e) {} }
  function within(k) { var t = +get(k) || 0; return t && (Date.now() - t) < COOLDOWN; }

  var path = location.pathname.replace(/\/+$/, '') || '/';
  var quiet = /^\/(cart|checkout|checkouts|account)(\/|$)|^\/pages\/(home-fragrance-course|bulk-orders|corporate-gifting)$/.test(path);
  var signed = get(K_SIGNED) === '1';
  var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;

  var pages = (+get(K_PAGES) || 0) + 1; set(K_PAGES, pages);
  var engaged = +get(K_MS) || 0;

  var teaser = document.querySelector('[data-mk-welcome-teaser]');
  var opened = false, lastFocus = null, maxScroll = 0;
  var baseTitle = document.title, altTitle = 'Your 10% off is waiting · Mikaya';

  function show() {
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mk-welcome-open');
    var input = root.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 80);
  }
  function autoOpen() {
    /* 2026-09-16: Yash asked for no interrupting popup. The left-edge tab is
       the only entry point now; the offer opens only when someone clicks it. */
    return;
    /* eslint-disable no-unreachable */
    if (opened || signed || quiet || within(K_AUTO)) return;
    set(K_AUTO, Date.now());
    show();
  }
  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mk-welcome-open');
    opened = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Manual openers anywhere (teaser, cart and PDP "Get code" links) always work.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mk-welcome-teaser-close]')) {
      e.preventDefault(); set(K_TEASE_OFF, Date.now()); hideTeaser(); return;
    }
    if (e.target.closest('[data-mk-welcome-open]')) { e.preventDefault(); show(); }
  });

  function showTeaser() {
    if (!teaser || signed || quiet || within(K_TEASE_OFF)) return;
    teaser.hidden = false;
    requestAnimationFrame(function () { teaser.classList.add('is-in'); });
  }
  function hideTeaser() { if (teaser) { teaser.classList.remove('is-in'); teaser.hidden = true; } }

  // ---- engaged-time clock (only counts while the tab is visible) ----
  var teased = false;
  window.addEventListener('load', function () { setTimeout(function () { if (!teased) { teased = true; showTeaser(); } }, TEASER_AFTER); });
  function tick() {
    if (document.hidden) return;
    engaged += 1000;
    if (engaged % 5000 === 0) set(K_MS, engaged);
    if (!teased && engaged >= TEASER_AFTER) { teased = true; showTeaser(); }
    if (!fine && engaged >= MOBILE_AFTER && (maxScroll >= 0.5 || pages >= 2)) autoOpen();
  }
  if (!signed && !quiet) {
    if (engaged >= TEASER_AFTER) { teased = true; showTeaser(); }
    setInterval(tick, 1000);
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0) maxScroll = Math.max(maxScroll, scrollY / h);
    }, { passive: true });
    if (fine) {
      document.addEventListener('mouseout', function (e) {
        if (engaged >= DESKTOP_MIN && e.clientY <= 0 && !e.relatedTarget) autoOpen();
      });
    }
    // gentle tab-title nudge while the visitor is on another tab
    document.addEventListener('visibilitychange', function () {
      if (signed || engaged < TEASER_AFTER) return;
      if (document.hidden) { baseTitle = document.title; document.title = altTitle; }
      else if (document.title === altTitle) { document.title = baseTitle; }
    });
    window.addEventListener('pagehide', function () { set(K_MS, engaged); });
  }

  // ---- close interactions ----
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mk-welcome-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  // ---- email submit (AJAX, no reload) ----
  var form = root.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) { input.reportValidity(); return; }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      function done() {
        signed = true; set(K_SIGNED, '1'); hideTeaser();
        if (document.title === altTitle) document.title = baseTitle;
        var f = root.querySelector('[data-mk-welcome-step="form"]');
        var s = root.querySelector('[data-mk-welcome-step="success"]');
        if (f) f.hidden = true;
        if (s) s.hidden = false;
      }
      fetch(form.getAttribute('action') || location.pathname, {
        method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' }
      }).then(done).catch(done);
    });
  }
})();
